<dl class="grid-container vertical-gutter-lg">
    <button
        class="button -blue -sqr"
        type="button"
        aria-label="Rechnungsadresse bearbeiten"
        (click)="edit.emit()"
    >
        <i ctrlIcon="pen"></i>
    </button>
    @if (isBusinessAccount()) {
        <app-portal-widget-details
            class="g-12 xs:g-6"
            heading="Schule/Verein/Firma"
            [detail]="customer().company"
        />
        <app-portal-widget-details
            class="g-12 xs:g-6"
            heading="Ansprechperson"
            [detail]="customer().fullName"
        />
    } @else {
        <app-portal-widget-details
            class="g-12 xs:g-6"
            heading="Anrede"
            [detail]="customer().title.description"
        />
        <app-portal-widget-details
            class="g-12 xs:g-6"
            heading="Name"
            [detail]="customer().fullName"
        />
        <app-portal-widget-details
            class="g-12 xs:g-6"
            heading="Geburtsdatum"
            [detail]="customer().dateOfBirth"
        />
    }
    <app-portal-widget-details
        class="g-12 xs:g-6"
        heading="Straße & Hausnr."
        [detail]="customer().street"
    />
    <app-portal-widget-details
        class="g-6"
        heading="PLZ"
        [detail]="customer().zip"
    />
    <app-portal-widget-details
        class="g-6"
        heading="Ort"
        [detail]="customer().city"
    />
    <app-portal-widget-details
        class="g-12 xs:g-6"
        heading="Telefon"
        [detail]="customer().phone"
    />
</dl>
